// extracted by mini-css-extract-plugin
export default {"wrapper":"LiveMarket_wrapper__SeVJw","main":"LiveMarket_main__fvXOn","button":"LiveMarket_button__IeAdj","icon":"LiveMarket_icon__pGElN"};